export default __webpack_public_path__ + "static/footer-people-20769086cb07cb4a629d47c249ba2226.png";